import imgError from 'assets/img/img_error.png';
export const HandleMediaError = (e) => {
  e.target.src = imgError;
};
